module.exports = __webpack_public_path__ + "img/satisfied-colored-icon.ae8210d8.svg";